<template>
    <div class="image-gallery">
      <div class="image-frame" v-for="(testGalleryImg, index) in testGalleryImgs" :key="index">
        <img :src="require(`../assets/imgs/gallery/images/test/${testGalleryImg}`)" alt="" />
      </div>
    </div>
</template>
  
<script>
export default {
name: "TestPage",
data() {
    return {
    testGalleryImgs: this.$store.testGalleryImgsArr,
    };
},
};
</script>
  
<style scoped>
    .image-gallery {
        display: flex;
        flex-wrap: wrap;
        gap: 10px; /* Spacing between frames */
    }

    .image-frame {
        flex: 0 0 30%;
        /* height: 200px; */
        overflow: hidden; /* Ensure content stays inside the frame */
        border: 1px solid #ccc; /* Optional: Add a border to the frame */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .image-frame img {
        width: 100%;
        height: 100%;
        object-fit: cover; /* Ensures image covers the frame without distortion */
        object-position: center; /* Center the image in the frame */
    }
</style>

<!-- height: 100%; -->